import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AwsAuthService } from 'src/app/services/aws-auth.service';
import { LanguageService } from 'src/app/services/language.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss']
})
export class MainPageComponent implements OnInit {
  highlightRegionContainer: any;
  parentContainer: any;
  logstatus: any;
  currentUser: any;
  translationData = [];
  languageId: string|null;
  isPageNotFound = false;
  language = '';
  participantDataToAnonymize: any;
  isProd:boolean = false;
  videoSrc = ''
  bgVideoClass = '';
  constructor(private readonly router: Router, 
    private readonly route: ActivatedRoute, private readonly awsAuth: AwsAuthService, 
    private readonly translationService: TranslationService, private readonly languageService: LanguageService) { 
    this.languageId = this.route.snapshot.paramMap.get('languageId');
    if (this.languageId && languageService.checkIsValideLanguage(this.languageId)) {
      this.isPageNotFound = false
    } else {
      this.isPageNotFound = true;
    }

    const anonymizeParticipantData = sessionStorage.getItem('anonymizeParticipant');
    if (anonymizeParticipantData) {
      this.participantDataToAnonymize = anonymizeParticipantData;      
    }

  }

  ngOnInit(): void {
    this.setVideoSource();
    this.language = this.languageService.getLanguage();
    let featureFlag = this.translationService.featureFlags;
    this.isProd = featureFlag?.general.tempProdFlag;
   
    this.currentUser = this.awsAuth.getUserLoggedInStatus();
    // for prod environment, show the landing page
    // for non prod environment, if user is logged in, redirect to explore page
    if (!this.isProd && this.currentUser) {
      this.goToExplore();
    }
  }

  goToExplore(){
    this.router.navigateByUrl('/'+this.language+'/explore');
  }

  triggerLogin() {
    this.awsAuth.signIn();
    this.logstatus = true
  }

  closeAnonymizationPopup(status: boolean) {
    this.participantDataToAnonymize = undefined;
    
  }


  @HostListener('window:resize')
  onResize() {
    this.setVideoSource();
  }

  setVideoSource() {
    const width = window.innerWidth;
    this.bgVideoClass = width > 1080 ? 'landscape' : 'portrait';

    this.videoSrc = width > 1080
      ? '../../../assets/media/landscape-stories.mp4'
      : '../../../assets/media/portrait-stories.mp4';
  }
 

}
